module.exports = __webpack_public_path__ + "img/employees.182b9755.svg";